import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { AgendaItemActivity, AgendaItemActivityModel } from 'src/app/models/activities';
import { DataEntity } from 'src/app/models/data-entities';
import {
  DataService,
  TemplateService,
  WorkflowContextService,
  WorkflowService
} from 'src/app/services';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { FormActivityEditorComponent } from '../../form-activity-editor/form-activity-editor.component';
import { ToastrService } from 'ngx-toastr';
import { DragulaService } from 'ng2-dragula';

@Component({
    selector: 'wm-agenda-item-activity-editor',
    templateUrl: './agenda-item-activity-editor.component.html',
    styleUrls: ['./agenda-item-activity-editor.component.css'],
    standalone: false
})
export class AgendaItemActivityEditorComponent
  extends FormActivityEditorComponent
  implements OnInit, OnDestroy {
    
  @ViewChild('agendaItemTemplate', { static: false }) agendaItemTemplate: any;
  
  @Input() activity: AgendaItemActivity;

  loadFull = false;
  ballotForm: UntypedFormGroup;
  activityForm: UntypedFormGroup;
  entities: DataEntity[];
  agendaItemTemplateField: AbstractControl;

  public Editor = ClassicEditor;
  editorConfig = {
    toolbar: [
      'insertTable',
      'alignment',
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'undo',
      'redo'
    ]
  };

  constructor(
    @Inject(forwardRef(() => TemplateService))
      public _templateSvc: TemplateService,
    @Inject(forwardRef(() => WorkflowService))
      _workflowSvc: WorkflowService,
    @Inject(forwardRef(() => DataService))
      private _dataSvc: DataService,
    @Inject(forwardRef(() => WorkflowContextService))
      public _context: WorkflowContextService,
    _formBuilder: UntypedFormBuilder,
    toastr: ToastrService,
    dragulaSvc: DragulaService,
    ref: ChangeDetectorRef
  ) {
    super(_workflowSvc, _context, toastr, _formBuilder, dragulaSvc, ref);
  }

  ngOnInit() {
    // this.getClientAgendaTypes();
    // this.activity.model.formLayoutModel = new SingleColumnFormLayoutModel(
    //   this.activity
    // );

    this.ballotForm = this._fb.group({});

    if (this.loadFull) {
      this.init();
    }
  }

  ngOnDestroy(): void {
    this.loadFull = false;
  }

  // getClientAgendaTypes() {
  //   this._dataSvc.getAgendaTypes(this._context.client.id).subscribe(result => {
  //     this.agendaTypes = result;
  //   });
  // }

  // agenda item editor----------------------------------------------------->
  showDetails(e) {
    this.loadFull = true;
    this.init();
  }

  cleanup() {
    this.loadFull = false;
    this.activityForm = null;
  }

  init() {
    const activityGroup = this._fb.group({
      agendaItemTemplate: ['', Validators.required]
    });

    this.activityForm = activityGroup;

    this.agendaItemTemplateField = this.activityForm.controls[
      'agendaItemTemplate'
    ];
    this.agendaItemTemplateField.setValue(
      this.activity.agendaItemTemplate || ''
    );

    this._workflowSvc
      .getDataEntitiesBeforeMe(this.workflow, this.activity)
      .subscribe(entities => {
        this.entities = entities;
      });
  }

  insert(de: DataEntity) {
    const editor = this.agendaItemTemplate.editorInstance;

    editor.model.change(writer => {
      const insertPosition = editor.model.document.selection.getFirstPosition();
      writer.insertText(this._templateSvc.generateToken(de), insertPosition);
    });
  }

  onChange({ editor }: ChangeEvent) {
    const data = editor.data.get();
    this.activity.agendaItemTemplate = data;
  }
  // <-----------------------------------------------------agenda item editor

  requiresBallotChanged() {
    let model: AgendaItemActivityModel = (this.activity.model as AgendaItemActivityModel);

    if (!this.activity.requiresBallot) {
      model.reset();
      model.customNameCriteria = [];
      model.documentPath = '';
    }
  }
}
